module.exports = __webpack_public_path__ + "static/media/iStock-698623358.18c8cc8c.jpg";